import * as Yup from "yup";
import {toast} from "react-toastify";
import React, {useEffect, useRef, useState} from "react";
import messageTypes from "../../../constants/MessagesTypes";
import {Form} from "@unform/web";
import CustomButton from "../../../components/Form/Button";
import {Link, useHistory} from "react-router-dom";
import {BiArrowBack} from "react-icons/bi";
import {IoMdCheckmark} from "react-icons/io";
import InputMask from "../../../components/Form/InputMask";
import {currencyFormat} from "../../../utils/masks";
import {InputAdornment} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {edit, getMeta, save} from "../../../services/Meta";
import AlertDelete from "../../../components/Alert/AlertDelete";
import {getBank} from "../../../services/Bank";
import {actions} from "../../../redux/actions";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    TradingListPageHeader,
    HeaderActions,
    TradingCard,
} from "../../Trading/styles";
import {StyledFormWrapper, ButtonContainer, FormRow} from "../../Trading/New/styles";
import styled from "styled-components";

const MetaSaveNarrow = styled.div`
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: relative;
    z-index: 2;
    margin-top: 16px;

    @media (min-width: 576px) {
        margin-top: 20px;
    }

    @media (min-width: 992px) {
        margin-top: 24px;
    }
`;

const MetaDeleteButton = styled.button`
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    border: none;
    color: #ffffff;
    padding: 10px 20px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 15px rgba(231, 76, 60, 0.35);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(231, 76, 60, 0.45);
    }

    @media (min-width: 768px) {
        padding: 12px 24px;
        font-size: 16px;
    }
`;

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const saveBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

export default function SaveMeta() {
    const [initialLoad, setInitialLoad] = useState(true);
    const [saving, setSaving] = useState(false);
    const [isDelete, setDelete] = useState(null);
    const [meta, setMeta] = useState(0);
    const formRef = useRef(null);
    const history = useHistory();
    const { coinType } = useSelector((state) => state.BankReducer);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    async function handleSubmmit(data) {
        try {
            if (saving) {
                return;
            }

            setSaving(true);
            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                stopWin: Yup.string().required(t('input_required')),
                stopLoss: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            let stopLoss = parseFloat(data.stopLoss.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            stopLoss = stopLoss > 0 ? stopLoss * -1 : stopLoss;
            formData.append('stopWin', data.stopWin.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            formData.append('stopLoss', stopLoss);
            const response = (meta) ? await edit(meta.id, formData) : await save(formData);

            if (response && response.status === 200) {
                toast.success(messageTypes.SUCCESS);
                getBank().then((d) => {
                    dispatch(actions.updateBank(d));
                });
                history.push('/meta');
            } else {
                toast.error(messageTypes.ERROR_SAVE);
            }
            setSaving(false);

        } catch (err) {
            setSaving(false);
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        getMeta().then((data) => {
            setMeta(data && Object.keys(data).length ? data : null);
        }).finally(() => setInitialLoad(false));
    }, []);

    useEffect(() => {
        if (isDelete) {
            getBank().then((data) => {
                dispatch(actions.updateBank(data));
            });
            history.push('/dashboard');
        }
    }, [isDelete, dispatch, history]);

    return (
        <TradingWrapper>
            <DivDiagonal />
            <ContentArea>
                {initialLoad ? (
                    <MetaSaveNarrow>
                        <TradingCard>
                            <StyledFormWrapper>
                                <div style={{ textAlign: 'center', padding: '32px 16px', color: '#b0b0b0' }}>
                                    {t('loading')}
                                </div>
                            </StyledFormWrapper>
                        </TradingCard>
                    </MetaSaveNarrow>
                ) : (
                    <>
                        <TradingListPageHeader>
                            <h1>
                                <i className="fa fa-check-square" aria-hidden="true"/> {t('goal_card_title')}
                            </h1>
                            {meta && (
                                <HeaderActions>
                                    <MetaDeleteButton
                                        type="button"
                                        onClick={() => {
                                            setDelete(false);
                                        }}
                                    >
                                        <i className="fa fa-trash" aria-hidden="true"/> {t('delete')}
                                    </MetaDeleteButton>
                                    {isDelete === false && (
                                        <AlertDelete
                                            text={t('goal_alert_confirm_delete')}
                                            setSuccessDelete={setDelete}
                                            urlDelete={process.env.REACT_APP_API_ENDPOINT + `/api/meta/delete/${meta.id}`}
                                        />
                                    )}
                                </HeaderActions>
                            )}
                        </TradingListPageHeader>

                        <MetaSaveNarrow>
                            <TradingCard>
                                <StyledFormWrapper>
                                    <Form ref={formRef} onSubmit={handleSubmmit}>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <FormRow>
                                                    <InputMask
                                                        type="text"
                                                        name="stopWin"
                                                        label={t('goal_label_input_stop_win') + ' *'}
                                                        mask={'currency'}
                                                        defaultValue={(meta) ? currencyFormat(meta.stopWin) : null}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">{coinType}</InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </FormRow>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormRow>
                                                    <InputMask
                                                        type="text"
                                                        name="stopLoss"
                                                        label={t('goal_label_input_stop_loss') + ' *'}
                                                        mask={'currency'}
                                                        defaultValue={(meta) ? currencyFormat(meta.stopLoss) : null}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">{coinType}</InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </FormRow>
                                            </div>
                                        </div>

                                        <ButtonContainer>
                                            <Link to="/meta" style={{ textDecoration: 'none' }}>
                                                <CustomButton
                                                    variant="outlined"
                                                    className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                                    startIcon={<BiArrowBack/>}
                                                    style={backBtnStyle}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    }}
                                                >
                                                    {t('btn_back')}
                                                </CustomButton>
                                            </Link>
                                            <CustomButton
                                                className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                                loading={saving}
                                                type="submit"
                                                startIcon={<IoMdCheckmark/>}
                                                style={saveBtnStyle}
                                                onMouseEnter={(e) => {
                                                    if (!saving) {
                                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                                }}
                                            >
                                                {t('btn_save')}
                                            </CustomButton>
                                        </ButtonContainer>
                                    </Form>
                                </StyledFormWrapper>
                            </TradingCard>
                        </MetaSaveNarrow>
                    </>
                )}
            </ContentArea>
        </TradingWrapper>
    );
}
